<template>
    <div class="checboxContainer" tabindex="0" @keydown="handleKeyDown" v-on:click.prevent="click">
        <label :class="{ disabled: disabled }" :for="inputId" class="checkboxLabel">
            {{ label }}
            <input
                :id="inputId"
                ref="checkboxInput"
                :checked="checked"
                :disabled="disabled"
                tabindex="-1"
                type="checkbox"
            />
            <span class="checkmark"></span>
        </label>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CheckBox',
    props: {
        label: { type: String, required: true },
        checked: { type: Boolean, required: true },
        disabled: { type: Boolean, required: false },
        partiel: { type: Boolean, required: false },
    },
    data() {
        return {
            inputId: 'checkbox-' + Math.random().toString(36).substring(2, 9),
        };
    },
    mounted() {
        this.updateIndeterminateState();
    },
    watch: {
        partiel() {
            this.updateIndeterminateState();
        },
    },
    methods: {
        click() {
            if (this.disabled === undefined || this.disabled !== true) {
                this.$emit('clickCheck');
            }
        },
        handleKeyDown(event) {
            if (event.code === 'Space' || event.code === 'Enter') {
                event.preventDefault();
                this.click();
            }
        },
        updateIndeterminateState() {
            if (this.$refs.checkboxInput) {
                this.$refs.checkboxInput.indeterminate = this.partiel;
            }
        },
    },
});
</script>

<style scoped>
.checboxContainer {
    display: flex;
    align-items: center;
}

.checkboxLabel {
    display: block;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
    font-size: 16px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.checkboxLabel input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 18px;
    width: 18px;
    border: 2px solid #666666;
    border-radius: 3px;
    background-color: #eee;
}

.checboxContainer:focus {
    outline: 2px solid var(--color-principal);
    outline-offset: 2px;
}

.checkboxLabel input:checked ~ .checkmark {
    background-color: #2196f3;
}

.checkmark:after {
    content: '';
    position: absolute;
    display: none;
}

.checkboxLabel input:checked ~ .checkmark:after {
    display: block;
}

.checkboxLabel .checkmark:after {
    left: 5px;
    top: 1px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}
.disabled {
    cursor: default;
    filter: grayscale(100%);
}
.checkboxLabel input:indeterminate ~ .checkmark {
    background-color: #2196f3;
}
.checkboxLabel input:indeterminate ~ .checkmark:after {
    display: block;
    left: 4px;
    top: 7px;
    width: 10px;
    height: 0;
    border-width: 3px 0 0 0;
    transform: rotate(0deg);
}
.checboxContainer:focus:not(:focus-visible) {
    outline: none;
}
</style>
